/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/email_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementAppGroupIdEmailSettings } from "./constants";
import type { GetEmailSettingsResponse } from "./types";

export const getEmailSettingsApiEndpoint = reactQueryFetcherAdapter(
  engagementAppGroupIdEmailSettings,
  (signal: AbortSignal, appGroupId: string): Promise<GetEmailSettingsResponse> => {
    return fetch(`/engagement/${appGroupId}/email_settings`, "GET", {}, { signal });
  }
);
